import moment from "jalali-moment";
import { ReactElement, useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import orderEnum from "../../enums/orderEnum";
import { popupSlice } from "../../services/reducers";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import { Sidebar } from "../../layouts/Sidebar";
import alertHandler from "../../utils/alertHandler";
import tools from "../../utils/tools";
import Excel from "./Excel";
import MergeRow from "./MergeRow";

const Merge = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [cars, setCars] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCar, setSelectedCar] = useState<any>({});
  const [selectedProduct, setSelectedProduct] = useState<any>({});
  const [data, setData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [tab, setTab] = useState("all");
  const [form, setForm] = useState<any>({});
  const [parts, setParts] = useState([]);
  const [brands, setBrands] = useState([]);
  const itemsPerPage = 25;
  // const endOffset = itemOffset + itemsPerPage;
  // let currentItems = products.filter(e => e.title?.toLowerCase()?.includes(query.toLowerCase()))?.slice(itemOffset, endOffset);
  // const pageCount = Math.ceil(products.length / itemsPerPage);

  const send = async () => {
    dispatch(setLoading(true));

    const res = await restApi(
      endpoints.merge.index + selectedCar.id,
      true,
    ).post(form);

    alertHandler(res, "محصولات با موفقیت ثبت شدند", () => {
      setForm({});
      fetchProduct();
    });

    dispatch(setLoading(false));
  };
  const list = () => {
    const rows: ReactElement[] = [];

    products
      .filter((e) => e.code?.includes(query))
      ?.map((product: any, index) => {
        rows.push(
          <MergeRow
            key={product.id}
            product={product}
            index={index}
            parts={parts}
            setForm={setForm}
            form={form}
            brands={brands}
          />,
        );
      });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      await restApi(endpoints.merge.car).get(),
      await restApi(endpoints.part.index).get(),
      await restApi(endpoints.brand.index).get(),
    ]);

    setCars(res[0].data);
    setParts(res[1].data);
    setBrands(res[2].data);

    dispatch(setLoading(false));
  };

  const fetchProduct = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.merge.product + selectedCar.id).get();

    setProducts(res.data);

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
    if (selectedCar.id) {
      fetchProduct();
    }
  }, [selectedCar]);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar />
        <div className="dashBoardMain">
          <h1 className="dashBoardTitle">لیست محصولات</h1>
          <div className="searchContainer">
            <div className="keepRight svgContainer">
              <span className="dashboardHeader clickable" onClick={send}>
                <p>ثبت محصولات</p>
                <i className="addPlus"></i>
              </span>
              <span
                className="dashboardHeader clickable"
                onClick={async () => restApi(endpoints.merge.sync.brand).get()}
              >
                <p>همگام سازی برند</p>
                <i className="addPlus"></i>
              </span>
              <span
                className="dashboardHeader clickable"
                onClick={async () => restApi(endpoints.merge.sync.part).get()}
              >
                <p>همگام سازی نوع کالا</p>
                <i className="addPlus"></i>
              </span>
              <span
                className="dashboardHeader clickable"
                onClick={() => dispatch(popupSlice.middle(<Excel />))}
              >
                <p>اکسل</p>
                <i className="addPlus"></i>
              </span>
            </div>
            <div className="dashboardseaechBox">
              <i className="dashMagnifierIcon"></i>
              <input
                className="dashSearchInput"
                placeholder="جستجو"
                onChange={(input) => setQuery(input.target.value)}
              />
            </div>
          </div>
          <div className="carPickerContainer">
            <Select
              options={tools.selectFormatter(cars, "id", "slug")}
              className="width45"
              value={tools.selectFormatter([selectedCar], "id", "slug")}
              onChange={(selected) =>
                setSelectedCar(cars.find((e) => e.id == selected.value))
              }
            />
            <label>:ماشین </label>
          </div>
          <table>
            <thead>
              <tr className="dashTr1">
                <th className="">نوع کالا</th>
                <th className="">برند</th>
                <th className="">URL</th>
                <th className="">عنوان</th>
                <th>عکس</th>
                <th>ردیف</th>
              </tr>
            </thead>
            <tbody>{list()}</tbody>
          </table>
          {/* <ReactPaginate */}
          {/*   breakLabel="..." */}
          {/*   nextLabel="بعدی >" */}
          {/*   onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)} */}
          {/*   pageRangeDisplayed={5} */}
          {/*   pageCount={pageCount} */}
          {/*   previousLabel="< قبلی" */}
          {/*   renderOnZeroPageCount={null} */}
          {/*   className="pagination" */}
          {/*   pageClassName="paginationBreak" */}
          {/*   previousClassName="paginationBreak" */}
          {/*   nextClassName="paginationBreak" */}
          {/*   activeClassName="paginationActive" */}
          {/* /> */}
        </div>
      </main>
    </>
  );
};
export default Merge;
